import React from 'react';
import HomeCirurgiasContainer from '../../../Container/Cirurgias/Home';

const Home = () => {
  return (
    <HomeCirurgiasContainer />
  );
};

export default Home;
